import {SvgIcon, useTheme} from '@mui/material';

export default function PlayIcon() {
	const theme = useTheme();
	return (
		<svg width="40" height="41" viewBox="0 0 40 41" fill="none">
			<path opacity="0.2" d="M19.9996 38.4166C18.8829 38.4166 17.7496 38.1332 16.7496 37.5499L6.84958 31.8332C4.84958 30.6666 3.59961 28.5166 3.59961 26.1999V14.7999C3.59961 12.4833 4.84958 10.3333 6.84958 9.16661L16.7496 3.44995C18.7496 2.28328 21.233 2.28328 23.2496 3.44995L33.1496 9.16661C35.1496 10.3333 36.3996 12.4833 36.3996 14.7999V26.1999C36.3996 28.5166 35.1496 30.6666 33.1496 31.8332L23.2496 37.5499C22.2496 38.1332 21.1163 38.4166 19.9996 38.4166ZM19.9996 5.08325C19.3163 5.08325 18.6162 5.2666 17.9996 5.6166L8.09958 11.3333C6.86625 12.0499 6.09961 13.3666 6.09961 14.7999V26.1999C6.09961 27.6166 6.86625 28.9499 8.09958 29.6666L17.9996 35.3832C19.2329 36.0999 20.7663 36.0999 21.9996 35.3832L31.8996 29.6666C33.133 28.9499 33.8996 27.6332 33.8996 26.1999V14.7999C33.8996 13.3833 33.133 12.0499 31.8996 11.3333L21.9996 5.6166C21.383 5.2666 20.6829 5.08325 19.9996 5.08325Z" fill="#00174C"/>
			<path d="M25.2503 21.8325C26.2759 21.2403 26.2759 19.7598 25.2503 19.1676L18.3272 15.1703C17.3016 14.5781 16.0195 15.3184 16.0195 16.5028L16.0195 24.4973C16.0195 25.6817 17.3016 26.4219 18.3272 25.8297L25.2503 21.8325Z" fill="#00174C"/>
		</svg>
	)
}





